export default "__VITE_ASSET__CB_4F$bU__"